var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemBellHidden = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M14.211 19.777a2.223 2.223 0 0 1-4.444 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.293 3.293a1 1 0 0 1 1.414 0l15 15a1 1 0 0 1-1.414 1.414l-1.04-1.04H4.213c-.99 0-1.485-1.198-.785-1.898l1.436-1.436v-5.098a7.07 7.07 0 0 1 1.123-3.834L4.293 4.707a1 1 0 0 1 0-1.414m3.32 4.734a4.9 4.9 0 0 0-.526 2.208v6.018l-.191.191h9.134z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M11.988 2A1.11 1.11 0 0 1 13.1 3.111v.096c3.405.534 6.013 3.473 6.013 7.028v5.028l-2.222-2.223v-2.805c0-2.703-2.2-4.902-4.903-4.902-.812 0-1.578.2-2.253.55l-1.62-1.618a7.1 7.1 0 0 1 2.763-1.058v-.096A1.11 1.11 0 0 1 11.988 2"
})));
export default SvgGemBellHidden;